import { useEffect, useMemo } from 'react';
import { TicketSalesResultType } from '@api';
import { useTicketSalesSellableStore } from './ticketSalesSellableStore';

export const useTicketSalesSellable = (
  results: TicketSalesResultType[]
): void => {
  const seedSellable = useTicketSalesSellableStore(
    (state) => state.seedSellable
  );

  const baseline = useMemo(
    () =>
      Object.fromEntries(
        results.map(({ ticketSalesId, ticketsSellable }) => [
          ticketSalesId,
          ticketsSellable,
        ])
      ),
    [results]
  );

  useEffect(() => {
    seedSellable(baseline);
  }, [baseline, seedSellable]);
};
